import { useSelector } from 'react-redux';
import {
    selectOfflineReportsAccountRequestsLoading,
    selectOfflineReportsAccountRequests,
} from 'store/offline-reports/selectors/offline-reports-selectors-factory';

export const useOfflineReportsAccountRequestsLoading = () => {
    const isLoading = useSelector(selectOfflineReportsAccountRequestsLoading);

    return isLoading;
};

export const useOfflineReportsAccountRequests = () => {
    const accountRequests = useSelector(selectOfflineReportsAccountRequests);

    return accountRequests;
};

